<app-sales-payment-information-kredicash-v3
  *ngIf="isFlowKrdya"
  (gotoStepEvent)="onGotoStep($event)"
  (nextStepEvent)="onNextStep()">
</app-sales-payment-information-kredicash-v3>

<app-sales-payment-information-kredicash-v2
  *ngIf="!isFlowKrdya"
  (gotoStepEvent)="onGotoStep($event)"
  (nextStepEvent)="onNextStep()">
</app-sales-payment-information-kredicash-v2>
